<div *ngFor="let item of items; let last = last">
    <a [routerLink]="item.route" [skipLocationChange]="false" class="small" *ngIf="!last">{{item.title}}</a>
    <i *ngIf="!last" class="nucicon_chevron_right"></i>
    <span *ngIf="last" class="last small">{{item.title}}</span>
</div>
